import { applicationSettingsQueryToForm as queryToForm } from './applicationQueryToForm';

export default {queryToForm}